import React from 'react';

export const HospitalityIcon: React.FC<{className?: string}> = ({className}) => (
    <svg xmlns="http://www.w3.org/2000/svg" className={className} fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5}>
        <path strokeLinecap="round" strokeLinejoin="round" d="M12 21.75c2.422 0 4.6-.91 6.237-2.423a9.75 9.75 0 00-12.474 0C7.4 20.84 9.578 21.75 12 21.75z" />
        <path strokeLinecap="round" strokeLinejoin="round" d="M12 4.5v17.25m4.237-14.803a5.25 5.25 0 00-8.474 0" />
        <path strokeLinecap="round" strokeLinejoin="round" d="M3 9.75h18" />
    </svg>
);